<template>
  <div>
    <select class="form-select"
            :aria-label="ariaLabel"
            :class="[computedSize]"
            v-model="localValue">
      <option :value="item" role="option" v-for="item in items" :key="item">{{ item }}</option>
    </select>
  </div>
</template>

<script>

export default {
  name: 'VSelect',
  props: {
    id: {
      type: String,
      required: true,
      default: null,
    },
    value: {},
    items: {
      type: [],
      required: true,
    },
    size: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    ariaLabel: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      localValue: this.value
    }
  },
  computed: {
    computedSize() {
      return this.size ? `form-select-${this.size}` : '';
    },
  },
  watch: {
    localValue(value) {
      this.$emit('input', value)
    },
    value(value) {
      this.localValue = value
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
